import { gql } from '@apollo/client';

const FRAGMENT_CATEGORIES_PAGE_CATEGORY = gql`
  fragment CategoriesPageCategory on Category {
    id
    folderName
    displayName
    disabled
    desc
    countPendingFiles
    sortedFiles {
      count
    }
  }
`;

export const GET_CATEGORY = gql`
  query GET_CATEGORY($id: ID!) {
    category(id: $id) {
      folderName
      displayName
      disabled
      desc
    }
  }
`;

export const GET_ALL_CATEGORIES = gql`
  query GET_ALL_CATEGORIES {
    categories {
      ...CategoriesPageCategory
    }
  }
  ${FRAGMENT_CATEGORIES_PAGE_CATEGORY}
`;

export const TOGGLE_DISABLED = gql`
  mutation TOGGLE_DISABLED($id: ID!, $input: UpdateCategoryInput!) {
    editCategory(id: $id, input: $input) {
      id
      disabled
    }
  }
`;

export const SORT_CATEGORY = gql`
  mutation SORT_CATEGORY($id: ID!) {
    sortCategory(id: $id) {
      id
    }
  }
`;

export const ADD_CATEGORY = gql`
  mutation ADD_CATEGORY($input: UpdateCategoryInput!) {
    addCategory(input: $input) {
      id
    }
  }
`;

export const EDIT_CATEGORY = gql`
  mutation EDIT_CATEGORY($id: ID!, $input: UpdateCategoryInput!) {
    editCategory(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DELETE_CATEGORY($id: ID!) {
    deleteCategory(id: $id)
  }
`;
